import { useEffect, useMemo, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UISection from 'UIComponents/section/UISection';
import { H2 } from 'UIComponents/elements/headings';
import isEqual from 'hs-lodash/isEqual';
import UIList from 'UIComponents/list/UIList';
import { formatEventProperties } from 'automation-ui-enrollment/utils/webhookUtils';
import WebhookPropertyMappingTable from 'automation-ui-enrollment/components/eventEnrollment/steps/WebhookPropertyMappingTable';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { getInitialMappingFromDropDown, mapWebhookDataToDropdownOptions } from 'automation-ui-enrollment/utils/webhookMappingUtils';
import UIAlert from 'UIComponents/alert/UIAlert';
import { useQuery } from 'data-fetching-client';
import { GET_WEBHOOK_MAX_ALLOWED_PROPERTIES } from 'automation-ui-enrollment/queries/WebhookQueries';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const FALLBACK_MAX_MAPPINGS = 50;
const WebhookPropertyMappingStep = ({
  webhookData,
  propertyMappings,
  setDisableNext,
  setPropertyMappings,
  setEventProperties
}) => {
  const {
    data: webhookMaxAllowedPropertiesData
  } = useQuery(GET_WEBHOOK_MAX_ALLOWED_PROPERTIES);
  const maxMappings = (webhookMaxAllowedPropertiesData === null || webhookMaxAllowedPropertiesData === void 0 ? void 0 : webhookMaxAllowedPropertiesData.webhookMaxAllowedProperties.numberOfProperties) || FALLBACK_MAX_MAPPINGS;
  const [mappings, setMappings] = useState(
  // If there are already mappings, then use those. Else create new mappings from webhookData
  propertyMappings.length > 0 ? propertyMappings.map(mapping => ({
    webhookMapping: mapping
  })) : getInitialMappingFromDropDown(mapWebhookDataToDropdownOptions(webhookData, [])));
  const dropDownOptions = useMemo(() => webhookData ? mapWebhookDataToDropdownOptions(webhookData, mappings) : [], [webhookData, mappings]);
  const hasTooManyMappings = mappings.length > maxMappings;
  const hasPropertyErrors = mappings.some(mapping => mapping.propertyError || mapping.nameError || mapping.enumError || mapping.typeError);

  // Validation
  useEffect(() => {
    const hasMappingErrors = hasTooManyMappings || hasPropertyErrors;
    setDisableNext(hasMappingErrors);

    // Remove any empty entries
    const filteredMappingsWithoutErrors = mappings.filter(({
      webhookMapping
    }) => webhookMapping.name && webhookMapping.property).map(({
      webhookMapping
    }) => webhookMapping);
    if (!isEqual(filteredMappingsWithoutErrors, propertyMappings)) {
      setPropertyMappings(filteredMappingsWithoutErrors);
      setEventProperties(formatEventProperties(filteredMappingsWithoutErrors));
    }
  }, [mappings, setDisableNext, setPropertyMappings, setEventProperties, propertyMappings, hasTooManyMappings, hasPropertyErrors]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(H2, {
      className: "text-center",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-enrollment.webhookWizard.setupEvent.properties.title"
      })
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-enrollment.webhookWizard.setupEvent.properties.review.description"
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(UIList, {
      ordered: true,
      styled: true,
      children: [/*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "automation-ui-enrollment.webhookWizard.setupEvent.properties.review.labelIt"
        })
      }), /*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "automation-ui-enrollment.webhookWizard.setupEvent.properties.review.defineData"
        })
      }), /*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "automation-ui-enrollment.webhookWizard.setupEvent.properties.review.removeOrAdd"
        })
      })]
    }), hasTooManyMappings ? /*#__PURE__*/_jsx(UISection, {
      children: /*#__PURE__*/_jsx(UIAlert, {
        type: "danger",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.webhookWizard.setupEvent.properties.tooManyMappingsError",
          options: {
            maxMappings
          }
        })
      })
    }) : null, hasPropertyErrors ? /*#__PURE__*/_jsx(UISection, {
      children: /*#__PURE__*/_jsx(UIAlert, {
        type: "warning",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.webhookWizard.setupEvent.properties.hasPropertyErrors"
        })
      })
    }) : null, /*#__PURE__*/_jsx(UISection, {
      children: /*#__PURE__*/_jsx(WebhookPropertyMappingTable, {
        mappings: mappings,
        hasTooManyMappings: hasTooManyMappings,
        setMappings: setMappings,
        dropDownOptions: dropDownOptions
      })
    })]
  });
};
export default WebhookPropertyMappingStep;